
        <ng-container kendoSliderLocalizedMessages
            i18n-dragHandleStart="kendo.rangeslider.dragHandleStart|The title of the **Start** drag handle of the Slider."
            dragHandleStart="Drag"
            i18n-dragHandleEnd="kendo.rangeslider.dragHandleEnd|The title of the **End** drag handle of the Slider."
            dragHandleEnd="Drag"
        >

        <div class="k-slider-wrap" #wrap
            [class.k-slider-topleft]="tickPlacement === 'before'"
            [class.k-slider-bottomright]="tickPlacement === 'after'"
            [kendoEventsOutsideAngular]="{ click: onWrapClick, keydown: onKeyDown }"
            >
            <div class="k-slider-track-wrap">
                <ul kendoSliderTicks
                    #ticks
                    *ngIf="tickPlacement !== 'none'"
                    [tickTitle]="title"
                    [vertical]="vertical"
                    [step]="smallStep"
                    [largeStep]="largeStep"
                    [min]="min"
                    [max]="max"
                    [labelTemplate]="labelTemplate?.templateRef"
                    [attr.aria-hidden]="true"
                >
                </ul>
                <div #track class="k-slider-track">
                    <div #sliderSelection class="k-slider-selection">
                    </div>
                    <a #draghandleStart
                        role="slider"
                        [id]="startHandleId"
                        [attr.tabindex]="disabled ? undefined : tabindex"
                        [attr.aria-valuemin]="min"
                        [attr.aria-valuemax]="max"
                        [attr.aria-valuenow]="value ? value[0] : null"
                        [attr.aria-valuetext]="valueText"
                        [attr.aria-disabled]="disabled ? true : undefined"
                        [attr.aria-readonly]="readonly ? true : undefined"
                        [attr.aria-orientation]="vertical ? 'vertical' : 'horizontal'"
                        [style.touch-action]="isDisabled ? '' : 'none'"
                        class="k-draghandle"
                        [title]="textFor('dragHandleStart')"
                        kendoDraggable
                        (kendoPress)="ifEnabled(handleDragPress ,$event)"
                        (kendoDrag)="ifEnabled(onHandleDrag ,$event)"
                        (kendoRelease)="ifEnabled(onHandleRelease, $event)"
                    ></a>
                    <a #draghandleEnd
                        role="slider"
                        [id]="endHandleId"
                        [attr.tabindex]="disabled ? undefined : tabindex"
                        [attr.aria-valuemin]="min"
                        [attr.aria-valuemax]="max"
                        [attr.aria-valuenow]="value ? value[1] : null"
                        [attr.aria-valuetext]="valueText"
                        [attr.aria-disabled]="disabled ? true : undefined"
                        [attr.aria-readonly]="readonly ? true : undefined"
                        [attr.aria-orientation]="vertical ? 'vertical' : 'horizontal'"
                        [style.touch-action]="isDisabled ? '' : 'none'"
                        class="k-draghandle"
                        [title]="textFor('dragHandleEnd')"
                        kendoDraggable
                        (kendoPress)="ifEnabled(handleDragPress ,$event)"
                        (kendoDrag)="ifEnabled(onHandleDrag ,$event)"
                        (kendoRelease)="ifEnabled(onHandleRelease, $event)"
                    ></a>
                </div>
            </div>
            <kendo-resize-sensor (resize)="sizeComponent()"></kendo-resize-sensor>
        </div>
  